/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=a0bdb790"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a0bdb790&lang=css"

import exportComponent from "/Users/yak/Documents/yak_work/burst_order_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__